module.exports = __webpack_public_path__ + "img/Icon-Withdrawal Requests.05137e4a.svg";